export enum ControlSectionTypes {
  VACANCIES = 'vacancies',
  STATUSES = 'statuses',
  SOURCES = 'sources',
  TAGS = 'tags',
  REGIONS = 'regions',
  HRS = 'hrs',
  INTERNSHIP_STATUSES = 'internship-statuses',
  SYSTEM = 'system'
}

export interface ControlPanelListResponse {
  data: ControlSectionTypes[];
}

export interface ControlPanelListState {
  items: ControlSectionTypes[];
  isLoading: boolean;
}
